import React from "react";

// Dashed boundary showing the printable-area margin. Purely a visual guide —
// carries the "no-print" class so it never shows up in an actual print/PDF.
export default function MarginBox({ margin, pageW, pageH }) {
  if (!margin) return null;
  return (
    <div
      className="no-print"
      style={{
        position: "absolute",
        left: margin.left,
        top: margin.top,
        width: Math.max(0, pageW - margin.left - margin.right),
        height: Math.max(0, pageH - margin.top - margin.bottom),
        border: "1px dashed #B9C1CC",
        pointerEvents: "none",
        zIndex: 1,
      }}
    />
  );
}
